import React from "react";
import { Container, Row, Col, Button, Accordion } from "react-bootstrap";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const NextArrow = ({ onClick }) => (
  <div className="slider-arrow next" onClick={onClick}>
    <FaChevronRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slider-arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </div>
);

const AITPRJ06 = () => {

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className="package-detail">

      {/* HERO SECTION */}
      <div
        className="package-hero-banner"
        style={{
          backgroundImage: "url('/Images/tour/1d0adf1b-074_big.jpg')",
        }}
      >
        <Container>
          <div className="hero-content">
            <h1>Rajasthan Royal Heritage Tour (AITP / RJ-06)</h1>

            <p className="hero-subtitle">
              5 Nights / 6 Days • Jaipur – Jodhpur – Udaipur
            </p>

            <div className="hero-price">
              Starting From <span>₹20,800*</span> / Per Person
            </div>
          </div>
        </Container>
      </div>

      <Container className="package-container">

        {/* SLIDER + ENQUIRY */}
        <Row className="mb-4">

          <Col lg={8}>
            <div className="package-slider">
              <Slider {...sliderSettings}>
                <img src="/Images/tour/9dba9405-be4_big.jpg" alt="" />
                <img src="/Images/tour/e93e62ed-2ca_big.jpg" alt="" />
                <img src="/Images/tour/bc6cb231-6f3_big.jpg" alt="" />
              </Slider>
            </div>
          </Col>

          <Col lg={4}>
            <div className="enquiry-sidebar">
              <h2>₹20,800*</h2>
              <p>Per Person</p>

              <Button variant="danger" className="mb-3">
                Book Now
              </Button>

              <form>
                <input type="text" placeholder="Your Name" />
                <input type="text" placeholder="Mobile Number" />
                <input type="date" />
                <input type="number" placeholder="Persons" />
                <textarea placeholder="Message"></textarea>

                <Button variant="dark">Send Enquiry</Button>
              </form>
            </div>
          </Col>

        </Row>

        {/* MAIN CONTENT */}
        <Row>
          <Col lg={8}>

            <div className="package-header">
              <h1>Rajasthan Royal Heritage Experience</h1>
              <p>Jaipur • Ajmer • Pushkar • Jodhpur • Udaipur</p>
            </div>

            {/* HIGHLIGHTS */}
            <div className="content-box highlight-box">
              <h3>Tour Highlights</h3>

              <Row>
                <Col md={6}>✔ Jaipur City Palace & Hawa Mahal</Col>
                <Col md={6}>✔ Amber Fort & Jal Mahal</Col>
                <Col md={6}>✔ Ajmer Sharif Dargah</Col>
                <Col md={6}>✔ Pushkar Brahma Temple</Col>
                <Col md={6}>✔ Mehrangarh Fort Jodhpur</Col>
                <Col md={6}>✔ Udaipur City Palace</Col>
                <Col md={6}>✔ Lake Pichola Cruise (Optional)</Col>
                <Col md={6}>✔ Cultural Rajasthan Experience</Col>
              </Row>
            </div>

            {/* OVERVIEW */}
            <div className="content-box">
              <h3>Overview</h3>
              <p>
                Discover the royal charm of Rajasthan covering the vibrant
                Pink City Jaipur, spiritual Ajmer & Pushkar, historic
                Jodhpur and romantic Udaipur — the City of Lakes.
                This tour blends heritage, spirituality and scenic beauty.
              </p>
            </div>

            {/* ITINERARY */}
            <div className="content-box">
              <h3>Day Wise Itinerary</h3>

              <Accordion defaultActiveKey="0">

                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Day 1 – Arrival Jaipur
                  </Accordion.Header>
                  <Accordion.Body>
                    Arrival pickup and transfer to hotel.
                    Visit City Palace, Jantar Mantar,
                    Ram Niwas Garden and drive past Hawa Mahal.
                    Overnight stay in Jaipur.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Day 2 – Jaipur Sightseeing
                  </Accordion.Header>
                  <Accordion.Body>
                    Visit Amber Fort overlooking Maota Lake,
                    drive past Jal Mahal, explore City Palace,
                    Jantar Mantar and local markets.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Day 3 – Jaipur to Jodhpur via Ajmer & Pushkar
                  </Accordion.Header>
                  <Accordion.Body>
                    Visit Ajmer Sharif Dargah and Pushkar
                    Brahma Temple & Pushkar Lake.
                    Continue drive to Jodhpur.
                    Overnight stay.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    Day 4 – Jodhpur to Udaipur
                  </Accordion.Header>
                  <Accordion.Body>
                    Visit Mehrangarh Fort including Moti Mahal
                    and Phool Mahal. Later drive to Udaipur.
                    Evening at leisure.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    Day 5 – Udaipur Sightseeing
                  </Accordion.Header>
                  <Accordion.Body>
                    Visit City Palace, Jagdish Temple,
                    Saheliyon Ki Bari and optional boat cruise
                    on Lake Pichola.
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                    Day 6 – Udaipur Departure
                  </Accordion.Header>
                  <Accordion.Body>
                    After breakfast check out from hotel
                    and drop at Udaipur Airport.
                  </Accordion.Body>
                </Accordion.Item>

              </Accordion>
            </div>

            {/* INCLUSIONS */}
            <div className="content-box">
              <Row>
                <Col md={6}>
                  <h4>Inclusions</h4>
                  <ul>
                    <li>Hotel accommodation</li>
                    <li>Daily breakfast</li>
                    <li>Private AC vehicle</li>
                    <li>All sightseeing tours</li>
                  </ul>
                </Col>

                <Col md={6}>
                  <h4>Exclusions</h4>
                  <ul>
                    <li>Monument entry fees</li>
                    <li>Boat ride charges</li>
                    <li>Personal expenses</li>
                    <li>Travel insurance</li>
                  </ul>
                </Col>
              </Row>
            </div>

            {/* HOTEL DETAILS */}
            <div className="content-box">
              <h3>Hotel Details</h3>
              <p>
                Comfortable deluxe hotels in Jaipur,
                Jodhpur and Udaipur ensuring pleasant stays
                throughout your Rajasthan journey.
              </p>
            </div>

            {/* RATE */}
            <div className="content-box">
              <h3>Rate & Summary</h3>
              <p>
                Starting price ₹20,800 per person on twin sharing basis.
                Rates may vary depending on season and availability.
              </p>
            </div>

            {/* TERMS */}
            <div className="content-box">
              <h3>Terms & Conditions</h3>
              <ul>
                <li>Booking subject to availability.</li>
                <li>Advance payment required.</li>
                <li>Cancellation policy applicable.</li>
              </ul>
            </div>

            {/* TRAVEL TIPS */}
            <div className="content-box">
              <h3>Travel Tips</h3>
              <ul>
                <li>Carry light cotton clothes.</li>
                <li>Keep comfortable walking shoes.</li>
                <li>Carry sunscreen & sunglasses.</li>
                <li>Winter evenings may be cool.</li>
              </ul>
            </div>

          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default AITPRJ06;